import React, { useState, useRef, useEffect } from 'react';
import { Menu, X, BellRing, Mail, LogOut, User, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SearchBar from './SearchBar';
import useGlobale from './global';

const Header = ({ isSidebarOpen, setIsSidebarOpen, user }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const { logout } = useGlobale();
    const navigate = useNavigate();

    // Fermer le dropdown si on clique en dehors
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <header className="bg-white shadow-sm sticky top-0 z-40 border-b border-gray-100">
            <div className="max-w-7xl mx-auto px-4">
                <div className="flex items-center justify-between h-16">
                    <button
                        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                        className="lg:hidden p-2 rounded-md hover:bg-[#F4F8E9]"
                    >
                        {isSidebarOpen ? (
                            <X className="w-6 h-6 text-[#437011]" />
                        ) : (
                            <Menu className="w-6 h-6 text-[#437011]" />
                        )}
                    </button>

                    <SearchBar className="hidden md:flex ml-4" />

                    <div className="flex items-center space-x-3">
                        <button className="p-2 rounded-full hover:bg-[#F4F8E9] relative">
                            <BellRing className="w-5 h-5 text-[#437011]" />
                            <span className="absolute top-1 right-1 w-2 h-2 bg-orange-500 rounded-full"></span>
                        </button>
                        <button className="hidden sm:block p-2 rounded-full hover:bg-[#F4F8E9]">
                            <Mail className="w-5 h-5 text-[#437011]" />
                        </button>

                        {/* Profile dropdown */}
                        <div className="relative" ref={dropdownRef}>
                            <button
                                onClick={() => setDropdownOpen(!dropdownOpen)}
                                className="flex items-center space-x-2 p-1.5 rounded-lg hover:bg-gray-50 transition-colors"
                            >
                                <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-semibold text-sm border border-orange-200">
                                    {user?.first_name?.[0] || 'U'}{user?.last_name?.[0] || ''}
                                </div>
                                <span className="hidden sm:block text-sm font-medium text-gray-700">
                                    {user?.first_name || 'User'}
                                </span>
                                <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
                            </button>

                            {dropdownOpen && (
                                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-100 py-1 z-50">
                                    <div className="px-4 py-2 border-b border-gray-100">
                                        <p className="text-sm font-medium text-gray-800">{user?.first_name} {user?.last_name}</p>
                                        <p className="text-xs text-gray-400">{user?.email}</p>
                                    </div>
                                    <button
                                        onClick={() => {
                                            navigate('/profile');
                                            setDropdownOpen(false);
                                        }}
                                        className="flex items-center w-full px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                                    >
                                        <User className="w-4 h-4 mr-3 text-gray-400" />
                                        Mon compte
                                    </button>
                                    <button
                                        onClick={() => {
                                            logout();
                                            setDropdownOpen(false);
                                        }}
                                        className="flex items-center w-full px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors"
                                    >
                                        <LogOut className="w-4 h-4 mr-3" />
                                        Déconnexion
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;